import * as React from 'react';
import {Modal} from 'antd';
import {STRINGS} from '../..';

interface ConfirmationModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: () => void;
  title?: string;
  message?: string;
  // TODO MM 'ghost' | 'dashed' |
  okType?: 'link' | 'default' | 'primary' | 'danger' | undefined;
  okText?: string;
  dataTestId?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  visible,
  title,
  onOk,
  onCancel,
  okType,
  okText = 'Yes',
  message,
  dataTestId,
}) => {
  return (
    <Modal
      closable={false}
      open={visible}
      title={title || STRINGS.confirmation.confirmation_default_title}
      onOk={() => onOk()}
      onCancel={() => onCancel()}
      okText={okText}
      cancelText="Cancel"
      okType={okType || 'primary'}
      destroyOnClose={true}
    >
      <p data-testid={dataTestId}>{message || STRINGS.confirmation.confirmation_default_message}</p>
    </Modal>
  );
};
